import { Input, Label, InputError } from '@schibsted-svp/react-ui';
import { capitalize } from 'lodash';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import type { CategoryData } from './types';
import css from './PodcastAdPlacement.module.scss';

type PodcastAdPlacementPropsType = {
    adType: 'preroll' | 'midroll' | 'postroll';
    register: UseFormRegister<CategoryData>;
    errors: FieldErrors<CategoryData>;
};

export function PodcastAdPlacement({ adType, register, errors }: PodcastAdPlacementPropsType) {
    const adjustedAdType = capitalize(adType) as 'Preroll' | 'Midroll' | 'Postroll';

    return (
        <div className={css.roll}>
            <Label>{adType}</Label>
            <span>
                <span className={css.adType}>
                    <p>Sponsorship </p>
                    <Input
                        {...register(`additional.metadata.podcast_numberOf${adjustedAdType}Spons.value`)}
                        size="small"
                        className={css.numberInput}
                        placeholder="1"
                    />
                </span>
                <InputError className={css.error}>
                    {errors?.additional?.metadata?.[`podcast_numberOf${adjustedAdType}Spons`]?.value?.message}
                </InputError>
            </span>
            <span>
                <span className={css.adType}>
                    <p>Airtime </p>
                    <Input
                        {...register(`additional.metadata.podcast_numberOf${adjustedAdType}Ads.value`)}
                        size="small"
                        className={css.numberInput}
                        placeholder="1"
                    />
                </span>
                <InputError className={css.error}>
                    {errors?.additional?.metadata?.[`podcast_numberOf${adjustedAdType}Ads`]?.value?.message}
                </InputError>
            </span>
        </div>
    );
}
